<template>
  <div class="app-reset-password-confirmation">
    <slot name="txtBefore">
      <h2 class="text-3xl">Passwort setzen</h2>
    </slot>
    <div class="container-box">
      <div class="content-limiter" v-if="step !== 'success'">
        <template v-if="step !== 'token' || step !== 'password'">
          <div v-if="!urlToken" class="text-base">
            <p class="text-base">
              Wir haben dir per SMS einen 6-stelligen Code zukommen lassen.
            </p>
            <br />
            <p class="text-base">
              Bitte trage diesen in das folgende Feld (Token) ein, um dein Passwort ändern zu können.
            </p>
          </div>
          <div v-else class="text-base">
            <p class="text-base">
              Bitte vergebe nun dein neues Passwort.
            </p>
          </div>
          <ResetPasswordConfirmationToken
            v-if="!urlToken"
            :min-token-length="smsMinTokenLength"
            :max-token-length="smsMaxTokenLength"
          >
            <template #txtBefore><slot name="txtTokenBefore"></slot></template>
            <template #lblBefore><slot name="lblTokenBefore"></slot></template>
            <template #lblSMSCode><slot name="lblTokenSMSCode"></slot></template>
            <template #btnNext><slot name="btnTokenNext"></slot></template>
            <template #txtAfter><slot name="txtTokenAfter"></slot></template>
          </ResetPasswordConfirmationToken>
          <ResetPasswordConfirmationPassword>
            <template #txtBefore><slot name="txtPasswordBefore"></slot></template>
            <template #lblNewPassword><slot name="lblNewPassword"></slot></template>
            <template #errorMessagePasswortRules><slot name="errorMessagePasswortRules"></slot></template>
            <template #lblNewPasswordRepeat><slot name="lblNewPasswordRepeat"></slot></template>
            <template #errorMessagePasswordNotEqual><slot name="errorMessagePasswordNotEqual"></slot></template>
            <template #lblBirthdate><slot name="lblBirthdate"></slot></template>
            <template #errorMessageBirthdate><slot name="errorMessageBirthdate"></slot></template>
            <template #btnPasswordNext><slot name="btnPasswordNext"></slot></template>
            <template #txtAfter><slot name="txtPasswordAfter"></slot></template>
          </ResetPasswordConfirmationPassword>
        </template>
        <slot name="txtAfter"></slot>
      </div>
      <div class="pw-reset-success" v-if="step === 'success'">
        <img src="files/lidl/images/new-icons/svg/check-circle.svg" alt="">
        <p>Glückwunsch, dein neues Passwort ist gespeichert!</p>
        <a :href="loginUrl" class="button button--primary --fit-content align-self-auto text-sm">Weiter zum Login
          <img src="files/lidl/images/new-icons/svg/arrow-right-to-bracket-white.svg" alt="">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ResetPasswordConfirmationToken from './Token.vue'
import ResetPasswordConfirmationPassword from './Password.vue'
import { mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'
export default {
  name: 'ResetPasswordConfirmationWrapper',
  mixins: [transaction('resetPasswordConfirmation')],
  components: {
    ResetPasswordConfirmationPassword,
    ResetPasswordConfirmationToken
  },
  data() {
    return {
      urlToken: null
    }
  },
  mounted() {
    const urlParameters = new URLSearchParams(window.location.search)
    const token = urlParameters.get('token')
    this.urlToken = token
    this.captureToken(token)
  },
  methods: {
    ...mapMutations('resetPassword', ['captureToken', 'resetProcess'])
  },
  computed: {
    ...mapGetters('resetPassword', ['step'])
  },
  props: {
    successBackButtonHref: {
      type: String,
      default: '#'
    },
    smsMinTokenLength: {
      type: Number,
      default: 6
    },
    smsMaxTokenLength: {
      type: Number,
      default: 8
    },
    loginUrl: {
      type: String,
      default: '#'
    }
  }
}
</script>
